module.exports = __webpack_public_path__ + "media/src/assets/images/lps-vs_graph_pc-17924c0e755e280a09c77037242162fb.png";